import { motion } from 'motion/react';
import { usePrefersReducedMotion } from '../effects/motionConfig';

export default function MotionButton({ children, className, onClick, type = 'button', disabled }) {
  const reduced = usePrefersReducedMotion();

  if (reduced) {
    return (
      <button type={type} className={className} onClick={onClick} disabled={disabled}>
        {children}
      </button>
    );
  }

  return (
    <motion.button
      type={type}
      className={className}
      onClick={onClick}
      disabled={disabled}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: 'spring', stiffness: 420, damping: 22 }}
    >
      {children}
    </motion.button>
  );
}
